<template>
  <div class="product-price-table-page col-block">
    <div class="info-container row-block" :style="{ height: '40px' }">
      <div class="info-title" v-html="'您已上傳 <b>' + this.pageData.total + '筆</b> 資料，<b>' + this.status.passed + '筆</b> 已通過管理員審核後收入資料庫，<b>' + this.status.failed + '筆</b> 未通過審核，<b>' + this.status.not_reviewed + '筆</b> 待審核。若有任何疑問請與管理員聯絡。'"></div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div class="table-main-container row-block" :style="{ flex: 1 }">
      <div v-if="onSearch" class="mask center-block">
        <!-- <img :src="require('../../assets/images/loading.gif')"> -->
        <img :src="require('../../assets/images/upload.svg')" alt="">
      </div>
      <div class="table-main-block col-block" :style="{ height: '100%', width: '100%' }">
        <div class="table-feild col-block" :style="{ flex: 1 }">
          <div class="table-container col-block" :style="{ height: '50px' }">
            <div class="thead default-shadow">
              <div class="tr row-block">
                <div
                  v-for="(option, index) in tableOptions"
                  :key="index"
                  class="th"
                  :class="option.class || ['row-block']"
                  :style="option.width ? { width: option.width } : { flex: 1 }"
                  @click="e => option.sort !== false && tableSortBy(option.value)"
                >
                  <span>{{ option.title }}</span>
                  <template v-if="option.sort !== false">
                    <div :style="{ width: '5px' }"></div>
                    <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.value)] || '')]" aria-hidden="true"></i>
                    <div :style="{ flex: 1 }"></div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="table-container col-block sub-shadow" :style="{ flex: 1 }">
            <div class="tbody" :style="{ flex: 1 }">
              <div :style="{ height: 0 }">
                <div class="tr row-block" v-for="(record, cindex) in records" :key="cindex">
                  <div class="container-block row-block">
                    <div
                      v-for="(option, index) in tableOptions"
                      :key="index"
                      class="td"
                      :class="option.class || ['row-block']"
                      :style="option.width ? { width: option.width } : { flex: 1 }"
                    >
                      <div v-if="option.value === '_CHECK'">
                        <div class="check center-block">
                          <img v-if="record.review_status === 'passed'" :src="require('../../assets/images/product-check-true.svg')" alt="">
                          <img v-else-if="record.review_status === 'failed'" :src="require('../../assets/images/product-check-false.svg')" alt="">
                          <div v-else-if="record.review_status === 'not_reviewed'"></div>
                        </div>
                      </div>
                      <div v-else-if="option.value === '_OPTIONS'">
                        <div class="option row-block">
                          <button type="button" name="button" class="main-button option-button" @click="e => detailProductPrice(record)">
                            <span>查看</span>
                          </button>
                        </div>
                      </div>
                      <span v-else :title="(option.display || (x => x))(record[option.value], cindex)" :style="(option.style || (() => {}))(record[option.value])">{{ (option.display || (x => x))(record[option.value], cindex) || '--' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="page-container center-block">
            <pageButtons
              v-if="pageData.total"
              :default="pageData.selectedPage"
              :display="pageData.display"
              :total="pageData.total"
              :buttonRange="pageData.buttonRange"
              @selectPage="page => { pageData.selectedPage = page; searchDatas() }"
            ></pageButtons>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getProductPrices } from '../../api'
import pageButtons from '../../components/tool/pageButtons'
import routeLoading from '../../mixins/routeLoading'
import { dateFormat } from '../../constants/global/util'

export default {
  components: {
    pageButtons
  },
  mixins: [
    routeLoading
  ],
  props: {
    update: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      records: [],
      status: {},
      pageData: {
        selectedPage: 1,
        display: 12,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: [],
        order: []
      },
      onSearch: false
    }
  },
  computed: {
    ...mapGetters([
      'countrys'
    ]),
    kindOptions () {
      return [
        { title: '蔬菜', value: 'vegetable' },
        { title: '水果', value: 'fruit' }
      ]
    },
    packingMethodOptions () {
      return [
        { title: '散裝', value: 'bulk', style: { color: '#EF6577' } },
        { title: '有包裝', value: 'packed', style: { color: '#3967A6' } },
        { title: '截切', value: 'cut', style: { color: '#3967A6' } }
      ]
    },
    marketKindOptions () {
      return [
        { title: '傳統市場', value: 'traditional_market' },
        { title: '批發市場', value: 'wholesale_market' },
        { title: '超市', value: 'supermarket' },
        { title: '量販店', value: 'hyper_market' },
        { title: '便利商店', value: 'convenience_store' },
        { title: '蔬果專賣店', value: 'vegetable_and_fruit_store' },
        { title: '農夫(假日)市集', value: 'farmers_market' }
      ]
    },
    countryOptions () {
      return this.countrys.map(([key, value]) => ({
        title: value.chinese_name + '(' + value.iso_name + ')',
        value: key
      }))
    },
    // static
    tableOptions () {
      return [
        {
          title: '',
          value: '_CHECK',
          width: '30px',
          class: ['center-block'],
          sort: false
        },
        {
          title: '拍攝日期',
          value: 'date',
          width: '120px',
          display: value => value ? dateFormat(new Date(value), 'yyyy/MM/dd') : ''
        },
        {
          title: '產品類別',
          value: 'kind',
          width: '100px',
          display: value => (this.kindOptions.find(option => option.value === value) || {}).title
        },
        {
          title: '作物(產品)',
          value: 'crop_name',
          width: '220px'
        },
        {
          title: '產地(國家)',
          value: 'country',
          width: '150px',
          display: value => (this.countryOptions.find(option => option.value === value) || {}).title || '無'
        },
        {
          title: '包裝方式',
          value: 'packing_method',
          width: '100px',
          display: value => (this.packingMethodOptions.find(option => option.value === value) || {}).title
        },
        {
          title: '價格',
          value: 'price',
          width: '100px'
        },
        {
          title: '貨幣單位',
          value: 'currency_name',
          width: '100px'
        },
        {
          title: '市場所在國家',
          value: 'market_country',
          width: '150px',
          display: value => (this.countryOptions.find(option => option.value === value) || {}).title
        },
        {
          title: '市場類型',
          value: 'market_kind',
          width: '150px',
          display: value => (this.marketKindOptions.find(option => option.value === value) || {}).title
        },
        {
          title: '管理',
          value: '_OPTIONS',
          class: ['center-block'],
          sort: false
        }
      ]
    }
  },
  watch: {
    'update' (nv, ov) {
      if (nv > ov) {
        this.fetchRecords()
      }
    }
  },
  methods: {
    ...mapActions([
      'setModalAction'
    ]),
    async fetchData () {
      await this.fetchRecords()
    },
    async fetchRecords () {
      try {
        let config = this.$ls.get('userInfo')
        let data = {}
        this.pageData.selectedPage && (data.page = this.pageData.selectedPage)
        this.pageData.display && (data.item_per_page = this.pageData.display)
        this.sort.value[0] && (data.order_by = this.sort.value[0])
        this.sort.order[0] && (data.order_method = this.sort.order[0].replace(/^-/, ''))
        let response = await getProductPrices(data, config)
        let records = response.data.data.elements
        this.pageData.total = response.data.data.items_count
        this.status = response.data.data.review_statuses
        this.records = records
      } catch (error) {
        throw error
      }
    },
    async searchDatas () {
      this.onSearch = true
      await this.fetchRecords()
      this.onSearch = false
    },
    detailProductPrice (record) {
      this.setModalAction({
        action: 'editProductPrice',
        width: '900px',
        customStyles: {
          padding: '0px',
          margin: '20px auto',
          borderRadius: '0'
        },
        param: {
          title: '查看零售價格資料',
          data: record,
          image: true,
          editable: false
        }
      })
    },
    tableSortBy (value) {
      let position = this.sort.value.indexOf(value)
      if (position === 0) {
        let order =
          this.sort.order[position] === '-asc' ? '-desc' : '-asc'
        this.sort.order.splice(position, 1)
        this.sort.order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sort.order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 0
        this.sort.value.splice(position, 1)
        this.sort.order.splice(position, 1)
        this.sort.value.unshift(value)
        this.sort.order.unshift(order || '-asc')
      }
      this.searchDatas()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/productPrice/table.vue